module.exports = __webpack_public_path__ + "img/image2.ab703e88.png";